import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {ParametersModule} from '@catmodules/models/parameters/parameters.module';
import {ModifyServiceComponent} from '@catmodules/models/services/components/modify-service/modify-service.component';
import {ServicesService} from '@catmodules/models/services/services/services.service';
import {UIBaseModule} from '@catui/ui-base.module';
import {UIFormModule} from '@catuiform/ui-form.module';

const publicComponents = [
  ModifyServiceComponent,
];

const imports = [
  CommonModule,
  FormsModule,
  UIBaseModule,
  UIFormModule,
  ReactiveFormsModule,
  ParametersModule,
];
const declarations = [
  ...publicComponents,
];

const exportings = [...publicComponents];

const providers = [ServicesService];
const entryComponents = [...publicComponents];

@NgModule({
  declarations,
  entryComponents,
  exports: exportings,
  imports,
  providers,
})
export class ServicesModule {
}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_release@2/app/Resources/Public/src/app/modules/models/services/services.module.ts